export function countOccurrence(counts: { [label: string]: number }, label: string) {
  if (counts[label]) {
    counts[label]++;
  } else {
    counts[label] = 1;
  }
}
